import { ChangeDetectorRef, Component, forwardRef, inject, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-password-input',
    imports: [
        MatIconModule,
        MatButtonModule,
        FormsModule,
        MatTooltipModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordInputComponent),
            multi: true
        }
    ],
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss', '../../route-components/login/login.component.scss']
})
export class PasswordInputComponent implements ControlValueAccessor {
  value = '';
  disabled = false;
  showPassword = false;
  @Input() placeholder = 'your password';
  private cdr = inject(ChangeDetectorRef);

  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(value: string) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  onMouseDown(event: MouseEvent, tt: MatTooltip) {
    event.preventDefault();          // keep focus on the input
    this.toggleShowPassword();       // flips your state

    // Ensure the new tooltip message is bound before we re-open it
    this.cdr.detectChanges();

    // Close any current instance, then re-open with the updated message.
    tt.hide(0);
    setTimeout(() => tt.show(0), 0);
  }

}
